import { instance, objectToParams } from './api';

export const getInventoriesByDeposit = (depositId, args) =>
  instance.get(`/api/v1/deposits/${depositId}/inventories?${objectToParams(args)}`);

export const getInventories = (args) => instance.get(`/api/v1/deposits/inventories?${objectToParams(args)}`);

export const getInventoriesStates = () => instance.get(`/api/v1/deposits/inventories/states`);

export const getInventoryById = (depositId, inventoryId) =>
  instance.get(`/api/v1/deposits/${depositId}/inventories/${inventoryId}`);

export const getInventoryStockById = (depositId, inventoryId, args) =>
  instance.get(`/api/v1/deposits/${depositId}/inventories/${inventoryId}/stock?${objectToParams(args)}`);

export const getInventoryStockRawById = (depositId, inventoryId, args) =>
  instance.get(`/api/v1/deposits/${depositId}/inventories/${inventoryId}/history?${objectToParams(args)}`).then((r) => {
    return {
      data: r.data,
      metadata: {
        page: 1,
        limit: 10,
      },
    };
  });

export const postInventory = (depositId, form) => instance.post(`/api/v1/deposits/${depositId}/inventories`, form);

export const postInventoryFileEPH = (form) => instance.post(`/api/v1/deposits/files/inventories/eph`, form);

export const postInventoryStock = (depositId, inventoryId, payload) =>
  instance.post(`/api/v1/deposits/${depositId}/inventories/${inventoryId}/stock`, payload);

export const postInventoryAction = (depositId, inventoryId, action) =>
  instance.post(`/api/v1/deposits/${depositId}/inventories/${inventoryId}/action/${action}`, {});

export const postCloseInventoryById = (depositId, inventoryId) => postInventoryAction(depositId, inventoryId, 'close');

export const deleteInventoryById = (depositId, inventoryId) =>
  instance.delete(`/api/v1/deposits/${depositId}/inventories/${inventoryId}`);
